import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import ImageR from '../assets/img/Icons/Icons/image.png'

import ImageQ from '../assets/img/Icons/Icons/imageQ.png'
import ImageC from '../assets/img/Icons/Icons/imagechat.png'
import Barside from '../assets/img/Icons/Icons/Icon-17.png'

import ImgcardHero from '../assets/img/Icons/Icons/bagde-hero.png'
import Footer from './footer'
const CoupensDetail = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17">
                    <div className="row mt-3">
                    <div className="col-sm-1-my17 ">
                        <Sidebar/>
                            {/* <p className="mb-0"><img src={Barside} className="Barside" alt="" /></p> */}
                        </div>
                      
                        <div className="col-sm-11-my17 text-center ">
                            <h5 className=" signin1-h1-top  mb-0">Coupon Details</h5>
                        </div>

                    </div>

                    <div className="row page17-p">
                        <div className="col-sm-12 py-2 ">
                            <hr className="mt-2 mb-0" />
                            <div className="row">
                                <div className="col-sm-12 px-0">
                                    <div>
                                        <img src={ImgcardHero} alt="" className="img-bagde-hero" />

                                    </div>
                                    <div className="bg-red bagde-top-hero product-bagde-hero">
                                        <h4 className="text-white p-2 text-center">Save <br />$ 1.00</h4>
                                    </div>
                                </div>
                            </div>
          <div className="scroll-inner3-cd">
          <div className="row   ">
                                <div className="col-sm-12 mt-4">
                                    <h5>Hadsome Coffee</h5>
                                    <h5>Save $1.00</h5>
                                    <p className="mb-0"><small className="text-secondary-light-gray " style={{ fontSize: "14px" }}>Lorem ipsum dolor sit amet consectetur adipisicing elit. At consequatur repellendus quidem ipsam nemo eveniet laborum molestiae fuga dolore unde nihil explicabo maxime doloribus ducimus, rem qui praesentium, in maiores!</small></p>
                                </div>
                                <div className="col-sm-12 bottom-btm-font mt-2 text-center">
                                    <button type="button" className="btn btn-success w-100 mt-3 py-2 ">Add To List</button>
                                    <hr />

                                </div>
                                <div className="col-sm-12">
                                    <p className="mb-0 text-center"><small className="text-dark fw500" style={{ fontSize: "18px" }}>Disclaimer</small></p>
                                    <p className="mt-3 mb-3 "><small className="text-dark " style={{ fontSize: "15px" }}> Lorem ipsum dolor sit amet consectetur adipisicing elit. At consequatur repellendus quidem ipsam nemo eveniet laborum molestiae fuga dolore unde nihil explicabo maxime doloribus ducimus, rem qui praesentium, in maiores! Lorem ipsum dolor sit amet consectetur adipisicing elit. At consequatur repellendus quidem ipsam nemo eveniet laborum molestiae fuga dolore unde nihil explicabo maxime doloribus ducimus, rem qui praesentium, in maiores!</small></p>

                                </div>
                            </div>
            
          </div>
          
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default CoupensDetail;

